import { IASIEntity } from "../../pages/client-hub-asi/components/model";
import { api } from "../../services/helpers";
import { HttpService } from "../http/HttpService";

const httpService = new HttpService(`${api}`);
const url = "sp-asi-devices";

export class ASIDeviceService {
  async create(payload: IASIEntity): Promise<any> {
    return await httpService.post(`/${url}`, payload);
  }

  async getList(hubId: string): Promise<any> {
    return await httpService.post(`/${url}/get-list`, { hubId });
  }

  async getPanelInfo(payload: any) {
    return await httpService.post(`/${url}/panel`, {
      hubId: payload.hubId,
      asiId: payload.asiId,
    });
  }

  async bindZonesToAsi(payload: any) {
    return await httpService.post(`/${url}/zones`, {
      asiId: payload.asiId,
      zoneIds: payload.zoneIds,
    });
  }

  async updateSchedule(
    asiId: string,
    schedule: {
      scheduleEnabled?: boolean;
      openSchedule?: {
        dayOfWeek: string;
        startTime: string;
        endTime: string;
      }[];
    }
  ): Promise<any> {
    return await httpService.post(`/${url}/${asiId}/schedule`, schedule);
  }
}
